<template>
    <span>{{ value | currency(currency, 0, { spaceBetweenAmountAndSymbol: ' ', symbolOnLeft: false }) }}</span>
</template>

<script>
import currency from '@/filters/currency.js';

export default {
    props: { value: { required: true }, hideCurrency: { type: Boolean } },
    filters: { currency },
    computed: {
        currency() {
            if (this.hideCurrency)
                return ''
            return this.$settings.currency.text;
        }
    },


}
</script>
